const forcedEnv = process.env.NEXT_PUBLIC_FORCED_ENV;

const envs = forcedEnv
  ? [forcedEnv]
  : [process.env.NODE_ENV, process.env.VERCEL_ENV, process.env.NEXT_PUBLIC_VERCEL_ENV];

module.exports = {
  isDev: envs.some((env) => env && ['development', 'preview'].includes(env)),
};
